export const useEventListener = (target, event, callback) => {
    target.addEventListener(event, callback)
    return () => target.removeEventListener(event, callback)
}